import {put,takeLatest  } from 'redux-saga/effects';
import NetworkHandler from '../net/NetworkHandler'
import {GET_FRIENDS} from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateCryodexLinks} from '../containers/Home/actions';
import {updateFriends} from '../containers/Home/actions';

function* getFriends(action){

    const Network = new NetworkHandler();
  
    try{
      const response = yield Network.getFriends(action);	 
	 
      if (!(response instanceof Error)) {
		  yield put(
			  updateFriends(response)
		  );
			localStorage.setItem("friends", JSON.stringify(response));
        } else {
          yield put(
            error({
              message: `Unable to get cryodex links. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to get cryodex links, please try again.${errorMsg}`,
            })
        );
    }

}

export default function* usersSagas() {
  yield takeLatest(GET_FRIENDS, getFriends);
}

